<div class="grid-x grid-margin-x" [formGroup]="formGroup">
  <div class="cell small-12 medium-12 large-12 text-align-center">
    <button class="button" (click)="assignCancel()">{{assignText}}</button>
  </div>
  @if (show) {
    <div class="cell small-5 medium-4 large-4 text-align-right">
      Select User:
    </div>
    <div class="cell small-4 medium-5 large-5`">
      <text-loader [run]="loading?.value" [text]="'Loading Users'" [tickType]="'.'" [interval]="1000"></text-loader>
      @if (users?.length > 0) {
        <ng-select [items]="users" bindValue="id" bindLabel="displayName" [placeholder]="" formControlName="assignee"></ng-select>
      }
    </div>
    <div class="cell small-3 medium-3 large-3">
      <span class="minor-margin-right"><button class="button" (click)="assignedUserChanged()" [disabled]="loading?.value">Assign</button></span>
      @if (confirm?.value) {
        <span class="bold">Reviewer Added</span>
      }
    </div>
  }
</div>